module.exports = __webpack_public_path__ + "b9f75e733a75f243b442394f67550ce9.svg";